module.exports = __webpack_public_path__ + "static/img/step-011.15bcded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-011.png
// module id = twFG
// module chunks = 1